/**
 * eSIM Index — portfolio comparison dataset. HONEST by design: these are the
 * portfolio's own eSIM EXPERIENCES compared by use-case/archetype. They share
 * ONE backend/catalog, so price is NOT the differentiator (the methodology says
 * so) — the experience is. NO fabricated ratings, review counts, or competitor
 * numbers live here. "bestFor" + "highlight" are qualitative, supportable notes.
 */
export type PortfolioEntry = {
  key: string;
  name: string;
  archetype: string;
  bestFor: string;
  highlight: string;
  /** internal route this experience is reached at (same shared backend in preview) */
  href: string;
};

// Ordered by a transparent "best for breadth of traveler" view, NOT by payout.
export const PORTFOLIO: PortfolioEntry[] = [
  { key: "esimsupra", name: "eSIMSUPRA", archetype: "Marketplace", bestFor: "Broad / general use", highlight: "Full destination catalog and balanced experience", href: "/destinations/" },
  { key: "coastal", name: "Coastal Freedom", archetype: "Lifestyle", bestFor: "Vacation / high-data", highlight: "Relaxed, photo-led plan picking for holidays", href: "/destinations/" },
  { key: "redigital", name: "Re-digital", archetype: "App / dashboard", bestFor: "App, global & top-ups", highlight: "Data-control dashboard and global/regional focus", href: "/destinations/" },
  { key: "photo", name: "Travel Connected", archetype: "Retail commerce", bestFor: "Mainstream trust-first", highlight: "Clear retail flow for first-time buyers", href: "/destinations/" },
  { key: "skylane", name: "SkyLane", archetype: "Airport / crisp", bestFor: "Frequent flyers", highlight: "Pre-flight, boarding-pass setup flow", href: "/destinations/" },
  { key: "aquaglobe", name: "AquaGlobe", archetype: "Premium / guided", bestFor: "Premium, guided setup", highlight: "Calm, premium, everything-handled feel", href: "/destinations/" },
  { key: "wanderlite", name: "WanderLite", archetype: "Beginner-friendly", bestFor: "Beginners / help-me-choose", highlight: "Plain-language guidance for newcomers", href: "/destinations/" },
  { key: "cobra", name: "eSIMCobra", archetype: "Bold / fast", bestFor: "Budget & quick setup", highlight: "Deal-led, no-frills activation", href: "/destinations/" },
];

export const COMPETITOR_NOTE =
  "We also track major market providers (e.g. Airalo, Holafly, Saily, Nomad, Ubigi). " +
  "Competitor pricing changes often, so we only publish provider figures from a maintained, " +
  "dated dataset — never estimated numbers.";
